<template>
  <b-card>
    <!-- form -->
    <validation-observer
      ref="updateUserForm"
      #default="{invalid}"
    >
      <b-form class="mt-2" @submit.prevent="saveInfo">
        <b-row>
          <b-col sm="6">
            <b-form-group
                :label="$t('First Name')"
                label-for="first-name"
              >
                <validation-provider
                  #default="{ errors, failedRules }"
                  name="First Name"
                  vid="firstname"
                  rules="required"
                >
                <b-form-input
                  v-model="optionsLocal.firstname"
                  :state="errors.length > 0 ? false:null"
                  :placeholder="$t('First Name')"
                  name="firstname"
                  @input="handleFirstNameInput"
                />
                <small class="text-danger" v-if="errors.length">{{ $t(`validation.${Object.keys(failedRules)[0]}`, {'_field_':$t('First Name')}) }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col sm="6">
            <b-form-group
              :label="$t('Last Name')"
              label-for="account-name"
            >
              <validation-provider
                #default="{ errors, failedRules }"
                name="Last Name"
                vid="lastname"
                rules="required"
              >
                <b-form-input
                  v-model="optionsLocal.lastname"
                  name="lastname"
                  :placeholder="$t('Last Name')"
                  @input="handleLastNameInput"
                />
                <small class="text-danger" v-if="errors.length">{{ $t(`validation.${Object.keys(failedRules)[0]}`, {'_field_':$t('Last Name')}) }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col sm="6">
            <div class="d-flex justify-content-between">
              <label for="email">{{ $t('Email') }}</label>
              <b-link :to="{name:'UserAccountSettingChangeEmail'}" v-if="$store.state.userData.parentId === null">
                <feather-icon icon="EditIcon" />
              </b-link>
            </div>
            <validation-provider
              #default="{ errors, failedRules }"
              name="Email"
              vid="email"
              rules="required|email"
            >
              <b-form-input
                disabled
                id="email"
                v-model="optionsLocal.email"
                :state="errors.length > 0 ? false:null"
                name="email"
                placeholder="john@example.com"
              />
              <small class="text-danger" v-if="errors.length">{{ $t(`validation.${Object.keys(failedRules)[0]}`, {'_field_':'Email'}) }}</small>
            </validation-provider>
          </b-col>
          <b-col sm="6">
            <div class="d-flex justify-content-between">
              <label for="phone">{{ $t('Mobile Phone') }}</label>
              <b-link :to="{name:'UserAccountSettingChangeCell'}">
                <feather-icon icon="EditIcon" />
              </b-link>
            </div>
              <input class="form-control" id="phone" disabled>
          </b-col>
          <b-col sm="6">
            <b-form-group
              :label="$t('Language')"
              label-for="account-language"
            >
              <validation-provider
                #default="{ errors, failedRules }"
                name="Language"
                vid="language"
                rules="required"
              >
                <vue-select
                  v-model="optionsLocal.language"
                  :reduce="option => option.value"
                  :filter="fuseSearch"
                  :options="localeOptions"
                  name="language"
                  :get-option-label="(option) => option.formalname"
                  :state="errors.length > 0 ? false:null"
                  :class="errors.length>0 ? 'form-control is-invalid':null"
                  @input="handleLanguageInput"
                >
                  <template #option="{ formalname, nativename }">
                    {{ formalname }}
                    <br />
                    <cite>{{ nativename }}</cite>
                  </template>
                </vue-select>
                <small class="text-danger" v-if="errors.length">{{ $t(`validation.${Object.keys(failedRules)[0]}`, {'_field_':$t('Language')}) }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <!-- alert -->
          <b-col
            cols="12"
            class="mt-75"
            v-if="!optionsLocal.iscellvalid"
          >
            <b-alert
              show
              variant="warning"
              class="mb-50"
            >
              <h4 class="alert-heading">
                {{ $t('Your phone number is not confirmed. Please check your sms message.') }}
              </h4>
              <div class="alert-body">
                <b-link class="alert-link">
                  {{ $t('Resend confirmation') }}
                </b-link>
              </div>
            </b-alert>
          </b-col>
          <!--/ alert -->
          

          <b-col cols="12">
            <b-button
              type="submit"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mt-2 mr-1"
              :disabled="invalid"
            >
              {{ $t('Save changes') }}
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import {
  ValidationProvider,
  ValidationObserver,
} from 'vee-validate/dist/vee-validate.full';
import {
  BButton, BForm, BFormGroup, BFormInput, BRow, BCol, BAlert, BCard, BCardText, BLink, BModal, VBModal
} from 'bootstrap-vue'
import VueSelect from 'vue-select'
import { mapState, mapMutations } from 'vuex';
import Ripple from 'vue-ripple-directive'
import Apicall from '@/libs/api-call'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

// import International Telephone Input
import intlTelInput from '@/libs/intl-tel-input/js/intlTelInput.js';
import utilsScript from '@/libs/intl-tel-input/js/utils.js'
import '@/libs/intl-tel-input//css/intlTelInput.css';
// import locale
import Locale from '@/libs/locale.json'
import Fuse from 'fuse.js'

import VOtpInput from "@bachdgvn/vue-otp-input";


export default {
  components: {
    BButton,
    BForm,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BAlert,
    BCard,
    BCardText,
    BLink,
    VueSelect,
    ValidationProvider,
    ValidationObserver,
    BModal,
    VBModal,
    VOtpInput,
    ToastificationContent,
  },
  directives: {
    Ripple,
  },
  props: {
    generalData: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  data() {
    return {
      optionsLocal: this.generalData,
      localeOptions: [],
      currentcountrycode: 'ca',
    }
  },
  computed: {
    ...mapState(['userForm']),
  },
  mounted() {
    if (this.userForm.firstname === '' && this.userForm.lastname === '' && this.userForm.language === '') {
      this.getMyAccountGeneral()
    } else {
      if (this.userForm.firstname !== '') {
        this.optionsLocal.firstname = this.userForm.firstname
      }
      if (this.userForm.lastname !== '') {
        this.optionsLocal.lastname = this.userForm.lastname
      }
      if (this.userForm.language !== '') {
        this.optionsLocal.language = this.userForm.language
      }
      this.getLocaleOptions(this.optionsLocal.language)
      this.generatePhoneNumber()
    }
  },
  methods: {
    ...mapMutations(['updateUserForm']),
    handleFirstNameInput(value) {
      this.updateUserForm({ ...this.userForm, firstname: value })
    },
    handleLastNameInput(value) {
      this.updateUserForm({ ...this.userForm, lastname: value })
    },
    handleLanguageInput(value) {
      this.updateUserForm({ ...this.userForm, language: value })
    },
    resetForm() {
      const self = this;
      self.optionsLocal = self.generalData;
    },
    getMyAccountGeneral() {
      this.getLocaleOptions(this.optionsLocal.language);
      this.generatePhoneNumber();
    },
    getLocaleOptions(_language) {
      const locales = Locale;
      this.localeOptions = [];
      var isSelected = false;
      const defaultLocale = ['fr_CA', 'en_US', 'es_LA', 'it_IT', 'hi_IN', 'nl']
      locales.forEach(element => {
        if (defaultLocale.includes(element.code) || (_language && (element.code === _language || element.formalname.toLowerCase() === _language.toLowerCase() || element.formalname.toLowerCase().slice(0, -1) === _language.toLowerCase()))) {
          this.localeOptions.push({"value": element.code, "formalname": element.formalname, "nativename": element.nativename});
        }
        if (this.optionsLocal.language && (element.code === this.optionsLocal.language || element.formalname.toLowerCase() === _language.toLowerCase() || element.formalname.toLowerCase().slice(0, -1) === _language.toLowerCase())) {
          this.optionsLocal.language = element.code;
          isSelected = true;
        }
      });
      if (!isSelected) this.optionsLocal.language = '';
    },
    generatePhoneNumber() {
      const input = document.querySelector("#phone");
      var cellcontainer = intlTelInput(input, {
        utilsScript: utilsScript,
        autoPlaceholder: "aggressive",
        separateDialCode: true,
        preferredCountries: ['fr','ca','be','us','mx'],
        initialCountry: "auto",
        autoPlaceholder: "off"
      });
      if (this.optionsLocal.cell !== null) {
        cellcontainer.setNumber('+'+this.optionsLocal.cell);
      }
    },
    fuseSearch(options, search) {
      const fuse = new Fuse(options, {
        keys: ['formalname', 'nativename'],
        shouldSort: true,
      })
      return search.length
        ? fuse.search(search).map(({ item }) => item)
        : fuse.list
    },
    saveInfo() {
      this.$refs.updateUserForm.validate().then(success => {
        const api = new Apicall();
        api.updateMyAccountGeneral(this.optionsLocal).then(response => {
          if (response.status === 'OK') { 
            const userData = JSON.parse(localStorage.getItem('userData') || '{}')
            userData.firstName = response.data.data.firstname
            userData.fullName = `${response.data.data.firstname} ${response.data.data.lastname}`
            userData.email = response.data.data.email
            localStorage.setItem('userData', JSON.stringify(userData))
            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                variant: 'success',
                title: this.$t('message.oneFieldUpdatedSuccess', {'_field_':this.$t('My Account')}),
                icon: 'CheckIcon'
              },
            });
            window.location.reload()
          } else {
            if (response.statuscode === 401) this.$router.push('Login');
            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                variant: 'danger',
                title: this.$t(response.msg),
                icon: 'XIcon',
              },
            });
          }
        });
      });
    },
  }
}
</script>
<style scoped>
.form-group .iti{
  position: relative;
  display: flex;
}
.v-select.form-control{
  padding: 0rem;
}
::v-deep input.otp-input {
  width: 40px;
  height: 40px;
  
}
::v-deep input.otp-input::-webkit-inner-spin-button,
::v-deep input.otp-input::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>